































































































//import process from 'process'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Address } from '@/models/Address'
import { SimpleLookupItem } from '@/models/SimpleLookupItem'
import { LookupService } from '@/services/LookupService'

import TextInput from '@/components/form/TextInput.vue'
import DropdownList from '@/components/form/DropdownList.vue'
import Checkbox from '@/components/form/Checkbox.vue'

import { RenderHelper } from '@/services/RenderHelper'

import { extend, localize } from 'vee-validate'

@Component({
  components: {
    TextInput,
    DropdownList,
    Checkbox
  },
  name: 'address-editor'
})
export default class AddressEditor extends Vue {
  private lookupService = new LookupService()

  @Prop({required: false, default: null}) classPrefix!: string | null
  @Prop({required: false, default: ""}) name!: string
  @Prop({required: true, default: null}) value!: Address
  @Prop({required: false, default: null}) title!: string
  @Prop({default: false}) showOtherState!: boolean
  @Prop({default: false}) hideCountryField!: boolean
  @Prop({required: false, default: false}) required!: boolean

  private helper = new RenderHelper()
  private hasAddress = false

  get address(): Address {
    return this.value
  }

  set address(value: Address) {
    this.$emit('input', value)
  }

  get showStateOtherField(): boolean {
    return (this.showOtherState && this.address.state?.toLowerCase() === 'other')
  }

  get showCountryField(): boolean{
    return !this.hideCountryField;
  }

  countries: SimpleLookupItem[] = []
  states: SimpleLookupItem[] = []


  setupValidation(): void {
    extend('nonAustralianState', {
      params: ['country'],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validate(value: string, { country }: Record<string, any>): boolean {
        if (value && value.length > 0) {
          if (country === 'AU') {
            return value.toLowerCase() === 'other'
          }
        }
        return true
      }
    })

    extend('postcode', {
      params: ['country'],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validate(value: string, { country }: Record<string, any>): boolean {
        if (value && value.length > 0) {
          if (country === 'AU') {
            const regex = /^\d{4}$/
            return regex.test(value)
          }
        }
        return true
      }
    })

    // Validation custom messages - localise the messages.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fields: any = {}

    fields[this.name + '_address1'] = {
      required: 'Please enter an address line'
    }
    fields[this.name + '_suburb'] = {
      required: 'Please enter an address line'
    }
    fields[this.name + '_state'] = {
      required: 'Please select a state option',
      nonAustralianState: 'You have selected a country other than Australia. Please enter your state by selecting OTHER and entering the name of the state'
    }
    fields[this.name + '_stateOther'] = {
      required: 'Please provide your state/region'
    }
    fields[this.name + '_country'] = {
      required: 'Please enter a country'
    }
    fields[this.name + '_postcode'] = {
      required: 'Please enter a post/zip code',
      postcode: 'Please enter a valid Australian postcode'
    }

    // Validation custom messages.
    localize({
      en: {
        fields
      },
    })
  }

  created (): void {

    this.hasAddress = this.required || this.helper.formatAddress(this.address).length > 0

    this.lookupService.GetCountries()
      .then((response) => {
        if (response !== null) {
          this.countries = response;
          return
        }
      })
      .catch((error) => {
        console.log(`Error retrieving Countries: ${error}`)
      })

    this.lookupService.GetAustralianStates(this.showOtherState)
      .then((response) => {
        if (response !== null) {
          this.states = response;
          return
        }
      })
      .catch((error) => {
        console.log(`Error retrieving Australian States: ${error}`)
      })


    // Validation custom messages.
    this.setupValidation()
  }
}
